import React, { Component } from "react";
import "./nosotros.css";
import { Image } from "react-bootstrap";

export default class Nosotros extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {}
  render() {
    return (
      <div className="navMargin" style={{ height: "100%" }}>
        <section
          style={{
            paddingTop: "2%",
            backgroundColor: "#352a35",
            display: "flex",
            flexDirection: "column",
            height: "auto",
            minHeight: "100%"
          }}
        >
          <p
            style={{
              color: "white",
              textAlign: "center",
              fontSize: "60pt",
              fontWeight: "Bold"
            }}
          >
            ¿Quiénes somos?
          </p>
          <Image
            src={require("../../img/lineNosotros.png")}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block"
            }}
            responsive
          />
          <div style={{ height: 25 }} />
          <div className={"container"} style={{ marginBottom: 40 }}>
            <p
              id="textoNosotros"
              style={{ color: "white", fontWeight: "bold", fontSize: "14pt" }}
            >
              Somos una editorial fundada por investigadores académicos
              mexicanos con probada experiencia en la docencia, investigación,
              asesoría y consultoría.
              <br />
              <br />
              Nuestro propósito es satisfacer las necesidades de los
              investigadores académicos relacionadas con la difusión de los
              resultados de sus investigaciones, a través de publicaciones en
              diversos e innovadores formatos (a precios accesibles) que les
              permitan cumplir con los criterios de evaluación de las instancias
              acreditadoras federales y estatales (SNI, PRODEP, CONACYT,
              Universidades Públicas, Universidades Privadas).
              <br />
              <br />
              T & R Editorial, ofrece para ello la edición de libros, en
              formatos impreso, electrónico e impreso/electrónico, de los
              siguientes géneros:
              <br />
              <br />
              <p style={{ marginBottom: 0, fontStyle: "italic" }}>
                - Libros académicos
              </p>
              <p style={{ marginBottom: 0, fontStyle: "italic" }}>
                - Libros de divulgación
              </p>
              <p style={{ marginBottom: 0, fontStyle: "italic" }}>
                - Libros de texto
              </p>
              <p style={{ marginBottom: 0, fontStyle: "italic" }}>
                - Libros histórico-culturales
              </p>
              <br />
              <br />
              T & R Editorial edita las siguientes Revistas Académicas
              electrónicas de periodicidad cuatrimestral:
              <br />
              <br />
              <p style={{ marginBottom: 0, fontStyle: "italic" }}>
                - Axon, especializada en Ciencias Sociales, Humanidades y
                Tecnología.
              </p>
              <p style={{ marginBottom: 0, fontStyle: "italic" }}>
                - Financial & Tax, especializada en Finanzas e Impuestos.
              </p>{" "}
              <p style={{ marginBottom: 0, fontStyle: "italic" }}>
                - Synapsis, especialidada en Innovación y Tecnología.
              </p>
              <br />
              <br />
              Ofrecemos asesoría y cursos para la redacción de textos académicos
              y la edición de libros, desde la gestación de su idea, hasta poner
              el libro en tus manos.
            </p>
          </div>
        </section>
      </div>
    );
  }
  componentDidMount() {}
  componentWillUnmount() {}
}

// moodle

// foros discusion grupal por correo

// llegar notificaciones por cada actividad

// foros grupales
// particular para cada alumno individual
// en individuales attatchmens

// retro alimentacion de los mensajes

// foro de equipos de personas

// en contenido solo texto y tener links para archivos

// curso estatico por ahora.

// presentaciones del curso
// indices de los cursos
// mensajes individuales
// colavoracion de foros grupales



// WEBPACK FOOTER //
// ./src/views/nosotros/index.js